(function(){'use strict';

var EGDE_IS_MOBILE_HP_SAFE = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;


/* ---- Existing: data-egde-anim observer ---- */
var animObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');animObserver.unobserve(entry.target);}});},{threshold:0.08,rootMargin:'0px 0px -40px 0px'});
document.querySelectorAll('[data-egde-anim]').forEach(function(el){animObserver.observe(el);});

/* ---- Existing: data-egde-parallax-bg ---- */
var parallaxBg=document.querySelector('[data-egde-parallax-bg]');
if(parallaxBg){var heroSection=parallaxBg.closest('[data-egde-parallax]');window.addEventListener('scroll',function(){var scrollY=window.pageYOffset;if(heroSection&&scrollY<heroSection.offsetHeight){parallaxBg.style.transform='translateY('+(scrollY*0.3)+'px) scale(1.06)';}},{passive:true});}

/* ---- Existing: counter observer ---- */
var counterObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){var el=entry.target;var target=parseInt(el.getAttribute('data-egde-count'),10);var current=0;var duration=1500;var step=Math.max(1,Math.ceil(target/(duration/16)));var suffix=target>=100?'+':'';function tick(){current=Math.min(current+step,target);el.textContent=current+suffix;if(current<target)requestAnimationFrame(tick);}tick();counterObserver.unobserve(el);}});},{threshold:0.5});
document.querySelectorAll('[data-egde-count]').forEach(function(el){counterObserver.observe(el);});

/* ====================================================
   NEW: Hero parallax (lightweight scroll-driven)
   Targets hero images inside #MainContent first sections
   ==================================================== */
(function(){
  var heroImg = document.querySelector('#MainContent .shopify-section:first-child img, #MainContent .shopify-section:nth-child(2) img');
  if (!heroImg) return;
  var parent = heroImg.closest('.shopify-section');
  if (!parent) return;
  var ticking = false;
  window.addEventListener('scroll', function(){
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function(){
        var rect = parent.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom > 0 && rect.top < vh) {
          var progress = -rect.top / (rect.height + vh);
          heroImg.style.transform = 'translateY(' + (progress * 40) + 'px) scale(1.03)';
        }
        ticking = false;
      });
    }
  }, {passive: true});
})();

/* ====================================================
   NEW: Slideshow parallax (flagship shop section)
   ==================================================== */
(function(){
  var slideshow = document.querySelector('.slideshow-section');
  if (!slideshow) return;
  var imgs = slideshow.querySelectorAll('img');
  if (!imgs.length) return;
  var ticking = false;
  window.addEventListener('scroll', function(){
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function(){
        var rect = slideshow.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom > 0 && rect.top < vh) {
          // 0 (top of viewport) → 1 (bottom of viewport)
          var progress = (vh - rect.top) / (vh + rect.height);
          // object-position: top(20%) at start → bottom(80%) at end
          var pos = 80 - progress * 60;
          imgs.forEach(function(img){
            img.style.objectPosition = 'center ' + pos + '%';
          });
        }
        ticking = false;
      });
    }
  }, {passive: true});
})();

/* ====================================================
   NEW: Section scroll fade-in
   Auto-applies to main content sections (not header, not marquee)
   ==================================================== */
(function(){
  var sections = document.querySelectorAll('#MainContent > .shopify-section');
  if (!sections.length) return;
  sections.forEach(function(sec){
    // Skip marquee and video sections
    if (sec.querySelector('#egde-marquee-scroll')) return;
    if (sec.querySelector('video')) return;
    sec.classList.add('egde-section-reveal');
  });
  var revealObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {threshold: 0.05, rootMargin: '0px 0px -30px 0px'});
  document.querySelectorAll('.egde-section-reveal').forEach(function(el){
    revealObserver.observe(el);
  });
})();

/* ====================================================
   Hero Card Slider: infinite manual loop + desktop autoplay
   ==================================================== */
(function(){
  var section = document.querySelector('[id*="video_brand_frontier"]');
  if (!section) return;

  var slideshowComp = section.querySelector('slideshow-component');
  var slidesContainer = section.querySelector('slideshow-slides');
  if (!slideshowComp || !slidesContainer) return;

  var isMobile = !!EGDE_IS_MOBILE_HP_SAFE;

  // Disable the theme autoplay. We drive desktop autoplay manually below.
  slideshowComp.removeAttribute('autoplay');
  slideshowComp.setAttribute('paused', '');
  if (typeof slideshowComp.pause === 'function') {
    setTimeout(function(){ try { slideshowComp.pause(); } catch (e) {} }, 100);
  }

  function init() {
    if (slidesContainer.dataset.egdeInfiniteLoop === 'true') return;

    var origSlides = Array.prototype.slice.call(slidesContainer.querySelectorAll('slideshow-slide:not(.clone)'));
    if (origSlides.length < 2) return;
    slidesContainer.dataset.egdeInfiniteLoop = 'true';

    var slideCount = origSlides.length;

    // Clone all slides before and after the real slide list. This keeps manual swipes seamless.
    var beforeFrag = document.createDocumentFragment();
    origSlides.forEach(function(slide) {
      var cloneBefore = slide.cloneNode(true);
      cloneBefore.classList.add('clone');
      cloneBefore.removeAttribute('aria-hidden');
      cloneBefore.removeAttribute('slide-id');
      beforeFrag.appendChild(cloneBefore);
    });
    slidesContainer.insertBefore(beforeFrag, slidesContainer.firstChild);

    var afterFrag = document.createDocumentFragment();
    origSlides.forEach(function(slide) {
      var cloneAfter = slide.cloneNode(true);
      cloneAfter.classList.add('clone');
      cloneAfter.removeAttribute('aria-hidden');
      cloneAfter.removeAttribute('slide-id');
      afterFrag.appendChild(cloneAfter);
    });
    slidesContainer.appendChild(afterFrag);

    var allSlides = Array.prototype.slice.call(slidesContainer.querySelectorAll('slideshow-slide'));
    var containerStyle = getComputedStyle(slidesContainer);
    var slideWidth = allSlides[0].offsetWidth;
    var gap = parseFloat(containerStyle.columnGap || containerStyle.gap) || 0;
    var containerPadding = parseFloat(containerStyle.paddingLeft) || 0;

    function slidePosition(slide) {
      return slide.offsetLeft - slidesContainer.offsetLeft - containerPadding;
    }

    function refreshMetrics() {
      allSlides = Array.prototype.slice.call(slidesContainer.querySelectorAll('slideshow-slide'));
      containerStyle = getComputedStyle(slidesContainer);
      slideWidth = allSlides[0] ? allSlides[0].offsetWidth : slideWidth;
      gap = parseFloat(containerStyle.columnGap || containerStyle.gap) || 0;
      containerPadding = parseFloat(containerStyle.paddingLeft) || 0;
    }

    function scrollToReal(index) {
      refreshMetrics();
      var realStart = slideCount;
      var target = allSlides[realStart + index];
      if (!target) return;
      slidesContainer.style.scrollBehavior = 'auto';
      slidesContainer.scrollLeft = slidePosition(target);
      slidesContainer.style.scrollBehavior = '';
    }

    requestAnimationFrame(function(){ scrollToReal(0); });

    var scrollTimeout;
    var isJumping = false;

    function updateCenterSlide() {
      var containerRect = slidesContainer.getBoundingClientRect();
      var centerX = containerRect.left + containerRect.width / 2;
      var closest = null;
      var closestDist = Infinity;
      allSlides.forEach(function(slide) {
        var rect = slide.getBoundingClientRect();
        var slideCenterX = rect.left + rect.width / 2;
        var dist = Math.abs(slideCenterX - centerX);
        if (dist < closestDist) {
          closestDist = dist;
          closest = slide;
        }
      });
      allSlides.forEach(function(slide) {
        slide.classList.toggle('is-center', slide === closest);
      });
    }

    function checkBounds() {
      refreshMetrics();
      var realFirstSlide = allSlides[slideCount];
      var realLastSlide = allSlides[slideCount * 2 - 1];
      if (!realFirstSlide || !realLastSlide) return;

      var scrollLeft = slidesContainer.scrollLeft;
      var firstRealPos = slidePosition(realFirstSlide);
      var lastRealPos = slidePosition(realLastSlide);

      if (scrollLeft < firstRealPos - slideWidth) {
        isJumping = true;
        var beforeOffset = firstRealPos - scrollLeft;
        slidesContainer.style.scrollBehavior = 'auto';
        slidesContainer.scrollLeft = lastRealPos - beforeOffset + slideWidth + gap;
        slidesContainer.style.scrollBehavior = '';
        requestAnimationFrame(function(){ isJumping = false; updateCenterSlide(); });
      } else if (scrollLeft > lastRealPos + slideWidth) {
        isJumping = true;
        var afterOffset = scrollLeft - lastRealPos;
        slidesContainer.style.scrollBehavior = 'auto';
        slidesContainer.scrollLeft = firstRealPos + afterOffset - slideWidth - gap;
        slidesContainer.style.scrollBehavior = '';
        requestAnimationFrame(function(){ isJumping = false; updateCenterSlide(); });
      }
    }

    slidesContainer.addEventListener('scroll', function() {
      if (isJumping) return;
      updateCenterSlide();
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(checkBounds, 50);
    }, { passive: true });

    window.addEventListener('resize', function() {
      refreshMetrics();
      checkBounds();
      updateCenterSlide();
    });

    requestAnimationFrame(function(){ setTimeout(updateCenterSlide, 100); });

    function autoAdvance() {
      refreshMetrics();
      slidesContainer.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
    }

    var autoTimer;
    function startAutoplay() {
      if (isMobile) return;
      stopAutoplay();
      autoTimer = setInterval(autoAdvance, 4000);
    }

    function stopAutoplay() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    if (!isMobile) {
      slideshowComp.addEventListener('mouseenter', stopAutoplay);
      slideshowComp.addEventListener('mouseleave', startAutoplay);
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      startAutoplay();
    }

    var controls = section.querySelector('slideshow-controls');
    if (controls) controls.style.display = 'none';
    var arrows = section.querySelector('slideshow-arrows');
    if (arrows) arrows.style.display = 'none';
  }

  setTimeout(init, 500);
})();


/* ====================================================
   Slide link-overlay click: force navigation
   (bypass Horizon theme's on:click="/select/N" handler)
   ==================================================== */
(function(){
  document.addEventListener('click', function(e) {
    var overlay = e.target.closest('.slide__link-overlay');
    if (overlay && overlay.href) {
      e.stopPropagation();
      e.preventDefault();
      window.location.href = overlay.href;
    }
  }, true); // capture phase — fires before slideshow-slide's on:click
})();

/* ====================================================
   Product Carousel (carousel_kEmBPB): Infinite loop
   ==================================================== */
(function(){
  if (EGDE_IS_MOBILE_HP_SAFE) return;
  var section = document.querySelector('[id*="carousel_kEmBPB"]');
  if (!section) return;

  var slidesContainer = section.querySelector('slideshow-slides');
  if (!slidesContainer) return;

  function init() {
    var origCards = slidesContainer.querySelectorAll('.card:not(.clone)');
    if (origCards.length < 2) return;

    var cardCount = origCards.length;

    // Clone all cards: prepend in-order (fragment), append in-order
    var beforeFrag2 = document.createDocumentFragment();
    origCards.forEach(function(card) {
      var cloneBefore = card.cloneNode(true);
      cloneBefore.classList.add('clone');
      cloneBefore.removeAttribute('aria-hidden');
      beforeFrag2.appendChild(cloneBefore);
    });
    slidesContainer.insertBefore(beforeFrag2, slidesContainer.firstChild);
    origCards.forEach(function(card) {
      var cloneAfter = card.cloneNode(true);
      cloneAfter.classList.add('clone');
      cloneAfter.removeAttribute('aria-hidden');
      slidesContainer.appendChild(cloneAfter);
    });

    var allCards = slidesContainer.querySelectorAll('.card');
    var cardWidth = allCards[0].offsetWidth;
    var gap = parseFloat(getComputedStyle(slidesContainer).gap) || 25;

    function scrollToReal(index) {
      var realStart = cardCount;
      var target = allCards[realStart + index];
      if (!target) return;
      var pos = target.offsetLeft - slidesContainer.offsetLeft -
                parseFloat(getComputedStyle(slidesContainer).paddingLeft);
      slidesContainer.scrollLeft = pos;
    }

    // Initial position
    requestAnimationFrame(function(){ scrollToReal(0); });

    var scrollTimeout;
    var isJumping = false;

    slidesContainer.addEventListener('scroll', function() {
      if (isJumping) return;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var realFirst = allCards[cardCount];
        var realLast = allCards[cardCount * 2 - 1];
        var scrollLeft = slidesContainer.scrollLeft;
        var containerPadding = parseFloat(getComputedStyle(slidesContainer).paddingLeft);
        var firstRealPos = realFirst.offsetLeft - slidesContainer.offsetLeft - containerPadding;
        var lastRealPos = realLast.offsetLeft - slidesContainer.offsetLeft - containerPadding;

        if (scrollLeft < firstRealPos - cardWidth) {
          isJumping = true;
          var offset = firstRealPos - scrollLeft;
          slidesContainer.style.scrollBehavior = 'auto';
          slidesContainer.scrollLeft = lastRealPos - offset + cardWidth + gap;
          slidesContainer.style.scrollBehavior = '';
          requestAnimationFrame(function(){ isJumping = false; });
        } else if (scrollLeft > lastRealPos + cardWidth) {
          isJumping = true;
          var offset = scrollLeft - lastRealPos;
          slidesContainer.style.scrollBehavior = 'auto';
          slidesContainer.scrollLeft = firstRealPos + offset - cardWidth - gap;
          slidesContainer.style.scrollBehavior = '';
          requestAnimationFrame(function(){ isJumping = false; });
        }
      }, 50);
    }, { passive: true });

    // Hide built-in controls
    var controls = section.querySelector('slideshow-controls');
    if (controls) controls.style.display = 'none';
  }

  setTimeout(init, 600);
})();

/* ---- Existing: Shopify editor support ---- */
if(window.Shopify&&window.Shopify.designMode){document.addEventListener('shopify:section:load',function(){document.querySelectorAll('[data-egde-anim]:not(.is-visible)').forEach(function(el){animObserver.observe(el);});document.querySelectorAll('[data-egde-count]').forEach(function(el){counterObserver.observe(el);});document.querySelectorAll('.egde-section-reveal:not(.is-visible)').forEach(function(el){el.classList.add('is-visible');});});}

/* ====================================================
   Move Instafeed between CONNECT WITH heading and SNS links
   ==================================================== */
(function(){
  function moveInstafeed(){
    var instafeed = document.getElementById('insta-feed');
    if (!instafeed || instafeed.dataset.moved === 'true') return true;

    var socialSection = document.querySelector('[id*="__social_links"]');
    if (!socialSection) return false;

    var wrapper = null;
    var divs = socialSection.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      if (divs[i].querySelector('h2') && divs[i].querySelector('a[href*="instagram"]')) {
        wrapper = divs[i]; break;
      }
    }
    if (!wrapper) return false;

    var linksGrid = null;
    for (var j = 0; j < wrapper.children.length; j++) {
      var ch = wrapper.children[j];
      if (ch.tagName === 'DIV' && ch.querySelector('a[href*="instagram"]')) {
        linksGrid = ch; break;
      }
    }
    if (!linksGrid) return false;

    linksGrid.insertAdjacentElement('beforebegin', instafeed);
    instafeed.dataset.moved = 'true';

    // Force spacing via inline styles (bypass app CSS specificity)
    var isMobile = window.innerWidth < 750;
    var topGap = isMobile ? '48px' : '80px';
    var botGap = isMobile ? '48px' : '80px';
    instafeed.style.setProperty('margin-top', topGap, 'important');
    linksGrid.style.setProperty('margin-top', botGap, 'important');

    // Hide now-empty instafeed section shell if any
    var shell = document.querySelector('[id*="17759677343d0f39e0"]');
    if (shell && !shell.querySelector('#insta-feed')) {
      shell.style.display = 'none';
    }
    return true;
  }

  var attempts = 0;
  var iv = setInterval(function(){
    attempts++;
    if (moveInstafeed() || attempts > 20) clearInterval(iv);
  }, 400);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveInstafeed);
  }
  window.addEventListener('load', moveInstafeed);
})();

})();

/* Shared fallback for the legacy blocks that continue below the wrapper. */
var EGDE_IS_MOBILE_HP_SAFE = window.matchMedia &&
  window.matchMedia('(max-width: 749px)').matches;


/* =====================================================
   PC HEADER LOGO — SCROLL-LINKED SHRINK
   Disables the CSS-transition based size toggle that
   theme's data-scroll-direction triggers, and instead
   updates the logo height every scroll frame in direct
   proportion to window.scrollY. Ghost-jitter on slow
   scrolls disappears because there is no animation to
   interrupt: every frame is the "final" value for that
   scroll position.
   PC only (min-width: 750px). On mobile, inline styles
   are cleared each frame so the existing CSS rules win.
   ===================================================== */
(function () {
  var SCROLL_RANGE = 1;
  var MAX_SIZE = 30;
  var MIN_SIZE = 30;
  var LERP = 1;
  var EPSILON = 0.5;

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  var current = MAX_SIZE;
  var target = MAX_SIZE;
  var rafId = null;

  function applySize(size) {
    var sizePx = size + 'px';
    var logos = document.querySelectorAll('.header-logo img, .header-logo__image');
    for (var i = 0; i < logos.length; i++) {
      logos[i].style.setProperty('height', sizePx, 'important');
      logos[i].style.setProperty('max-height', sizePx, 'important');
    }
  }

  function clearSize() {
    var logos = document.querySelectorAll('.header-logo img, .header-logo__image');
    for (var i = 0; i < logos.length; i++) {
      logos[i].style.removeProperty('height');
      logos[i].style.removeProperty('max-height');
    }
  }

  function recomputeTarget() {
    if (!isDesktop()) {
      clearSize();
      return false;
    }
    var t = Math.min(Math.max(window.scrollY / SCROLL_RANGE, 0), 1);
    target = MAX_SIZE - (MAX_SIZE - MIN_SIZE) * t;
    return true;
  }

  function tick() {
    var diff = target - current;
    if (Math.abs(diff) < EPSILON) {
      current = target;
      applySize(current);
      rafId = null;
      return;
    }
    current += diff * LERP;
    applySize(current);
    rafId = requestAnimationFrame(tick);
  }

  function onScroll() {
    if (!recomputeTarget()) return;
    if (rafId === null) rafId = requestAnimationFrame(tick);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onScroll);
  } else {
    onScroll();
  }
})();

/* HERO SLIDESHOW (slideshow_mAY6gk) - SEAMLESS INFINITE LOOP
   Approach: clone every original slide before & after the real
   slide list, autoplay just scrolls the slideshow-slides container
   by one slide width every 5s. A scroll-position watcher
   instantly snaps the container back to the equivalent position
   in the real slides whenever it crosses into the clones — so the
   loop looks completely seamless (no jump-back to start). */
(function () {
  function init() {
    var slideshow = document.querySelector('[id*="slideshow_mAY6gk"] slideshow-component');
    if (!slideshow) return;
    if (EGDE_IS_MOBILE_HP_SAFE) {
      slideshow.removeAttribute('autoplay');
      if (typeof slideshow.pause === 'function') { try { slideshow.pause(); } catch (e) {} }
      return;
    }
    var slidesContainer = slideshow.querySelector('slideshow-slides');
    if (!slidesContainer) return;

    var origSlides = Array.from(slidesContainer.querySelectorAll('slideshow-slide:not(.clone)'));
    if (origSlides.length < 2) return;
    var slideCount = origSlides.length;

    // Clone all slides into BEFORE and AFTER fragments
    var beforeFrag = document.createDocumentFragment();
    origSlides.forEach(function (slide) {
      var c = slide.cloneNode(true);
      c.classList.add('clone');
      c.setAttribute('aria-hidden', 'true');
      beforeFrag.appendChild(c);
    });
    slidesContainer.insertBefore(beforeFrag, slidesContainer.firstChild);

    var afterFrag = document.createDocumentFragment();
    origSlides.forEach(function (slide) {
      var c = slide.cloneNode(true);
      c.classList.add('clone');
      c.setAttribute('aria-hidden', 'true');
      afterFrag.appendChild(c);
    });
    slidesContainer.appendChild(afterFrag);

    var allSlides = slidesContainer.querySelectorAll('slideshow-slide');

    // Theme autoplay off; we drive it
    slideshow.removeAttribute('autoplay');
    if (typeof slideshow.pause === 'function') { try { slideshow.pause(); } catch (e) {} }

    function getSlideStride() {
      var gap = parseFloat(getComputedStyle(slidesContainer).columnGap || getComputedStyle(slidesContainer).gap) || 0;
      return allSlides[0].offsetWidth + gap;
    }
    function realFirstPos() {
      return allSlides[slideCount].offsetLeft - slidesContainer.offsetLeft;
    }
    function realLastPos() {
      return allSlides[slideCount * 2 - 1].offsetLeft - slidesContainer.offsetLeft;
    }

    // Initial position: first real slide (or whatever initial-slide says)
    function settleInitial() {
      var initial = parseInt(slideshow.getAttribute('initial-slide'), 10) || 0;
      var target = allSlides[slideCount + initial];
      slidesContainer.style.scrollBehavior = 'auto';
      slidesContainer.scrollLeft = target.offsetLeft - slidesContainer.offsetLeft;
      requestAnimationFrame(function () { slidesContainer.style.scrollBehavior = ''; });
    }
    requestAnimationFrame(settleInitial);
    // Also re-anchor after images may have shifted layout
    window.addEventListener('load', function () { setTimeout(settleInitial, 50); });

    var isJumping = false;
    var checkTimer = null;

    function checkBounds() {
      if (isJumping) return;
      var stride = getSlideStride();
      var firstPos = realFirstPos();
      var lastPos = realLastPos();
      var sl = slidesContainer.scrollLeft;

      // Crossed into appended clones (past the last real slide)
      if (sl > lastPos + stride * 0.5) {
        isJumping = true;
        var delta = sl - lastPos;
        slidesContainer.style.scrollBehavior = 'auto';
        slidesContainer.scrollLeft = firstPos + delta - stride;
        requestAnimationFrame(function () {
          slidesContainer.style.scrollBehavior = '';
          isJumping = false;
        });
      }
      // Crossed into prepended clones (before the first real slide)
      else if (sl < firstPos - stride * 0.5) {
        isJumping = true;
        var delta2 = firstPos - sl;
        slidesContainer.style.scrollBehavior = 'auto';
        slidesContainer.scrollLeft = lastPos - delta2 + stride;
        requestAnimationFrame(function () {
          slidesContainer.style.scrollBehavior = '';
          isJumping = false;
        });
      }
    }

    slidesContainer.addEventListener('scroll', function () {
      clearTimeout(checkTimer);
      checkTimer = setTimeout(checkBounds, 60);
    }, { passive: true });

    // Autoplay: smooth scroll one slide every 5s
    var autoTimer = null;
    function autoAdvance() {
      var stride = getSlideStride();
      slidesContainer.scrollBy({ left: stride, behavior: 'smooth' });
    }
    function start() { stop(); autoTimer = setInterval(autoAdvance, 5000); }
    function stop() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    /* Make in-slide anchors navigate normally — the theme's
       slideshow-component listens on the whole component and may
       hijack the click and preventDefault before navigation. By
       catching the click in the capture phase on the anchor and
       stopping propagation, we let the <a>'s default action run. */
    slidesContainer.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a) { e.stopPropagation(); }
    }, true);

    // Manual navigation: arrows scroll by one stride too
    var prevBtn = slideshow.querySelector('.slideshow-control--previous');
    var nextBtn = slideshow.querySelector('.slideshow-control--next');
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      slidesContainer.scrollBy({ left: -getSlideStride(), behavior: 'smooth' });
      start();
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      slidesContainer.scrollBy({ left: getSlideStride(), behavior: 'smooth' });
      start();
    });

    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 200);
  }
})();


/* =====================================================
   REBOOT IMAGE - vertical parallax (no zoom)
   Wrapper height is forced via JS to width / 1.7 (slightly
   flatter than the image's natural 1.508), so the image at
   natural size overflows top & bottom. The overflow is what
   we slide during scroll.
   ===================================================== */


/* ---- Reboot image srcset trim (cap at 1200w for faster loading) ---- */
(function () {
  function trim(img) {
    if (!img || !img.srcset || img.__egdeSrcOpt) return;
    img.__egdeSrcOpt = true;
    var MAX_W = EGDE_IS_MOBILE_HP_SAFE ? 1200 : 1920;
    var parts = img.srcset.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var filtered = parts.filter(function (p) {
      var m = p.match(/(\d+)w$/);
      if (!m) return true;
      return parseInt(m[1], 10) <= MAX_W;
    });
    if (filtered.length) {
      img.srcset = filtered.join(', ');
      if (EGDE_IS_MOBILE_HP_SAFE) {
        var largest = filtered[filtered.length - 1].split(/\s+/)[0];
        if (largest) img.src = largest;
      }
    }
    img.sizes = '100vw';
    if (EGDE_IS_MOBILE_HP_SAFE) {
      img.loading = 'lazy';
      img.fetchPriority = 'low';
      img.decoding = 'async';
    }
  }
  var existing = document.querySelector && document.querySelector('img[src*="260116reboot1"]');
  if (existing) { trim(existing); return; }
  var root = document.documentElement || document;
  var obs = new MutationObserver(function () {
    var i = document.querySelector('img[src*="260116reboot1"]');
    if (i) { trim(i); obs.disconnect(); }
  });
  try { obs.observe(root, { childList: true, subtree: true }); } catch (e) {}
  setTimeout(function () { try { obs.disconnect(); } catch (e) {} var i = document.querySelector('img[src*="260116reboot1"]'); if (i) trim(i); }, 8000);
})();

/* ---- Reboot parallax (CSS variable driven, scroll+rAF dual update) ---- */
(function () {
  var MOVE_PERCENT = 5;
  function init() {
    var img = document.querySelector('img[src*="260116reboot1"]');
    if (!img) return;
    var wrapper = img.closest('.image-block') || img.parentElement;
    if (!wrapper) return;
    wrapper.classList.add('egde-reboot-parallax');
    if (EGDE_IS_MOBILE_HP_SAFE) {
      wrapper.classList.add('egde-reboot-static-mobile');
      wrapper.style.setProperty('--egde-parallax-y', '0%');
      img.loading = 'lazy';
      img.fetchPriority = 'low';
      img.decoding = 'async';
      return;
    }
    img.loading = 'eager';
    img.fetchPriority = 'high';
    img.decoding = 'async';
    var lastScrollY = -1;
    function update(force) {
      var sy = window.scrollY;
      if (!force && sy === lastScrollY) return;
      lastScrollY = sy;
      var rect = wrapper.getBoundingClientRect();
      var vh = window.innerHeight;
      if (rect.bottom < 0 || rect.top > vh) return;
      var center = rect.top + rect.height / 2;
      var t = (center - vh / 2) / (vh / 2 + rect.height / 2);
      if (t > 1) t = 1; else if (t < -1) t = -1;
      var offset = t * MOVE_PERCENT;
      wrapper.style.setProperty('--egde-parallax-y', offset + '%');
    }
    function loop() { update(false); requestAnimationFrame(loop); }
    window.addEventListener('scroll', function () { update(false); }, { passive: true });
    window.addEventListener('resize', function () { update(true); });
    update(true);
    requestAnimationFrame(loop);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 200);
  }
})();


/* ---- Welcome gradient scroll-driven (sweep gradient color across heading) ---- */
(function(){
  function init(){
    if (EGDE_IS_MOBILE_HP_SAFE) return;
    var block=document.querySelector('[id*="product_list_ed3c8h"] .section-resource-list__header .image-block');
    if(!block)return;
    var lastSy=-1;
    function update(){
      var sy=window.scrollY;
      if(sy===lastSy)return;
      lastSy=sy;
      var rect=block.getBoundingClientRect();
      var vh=window.innerHeight;
      var center=rect.top+rect.height/2;
      var t=(vh-center)/vh;
      if(t<0)t=0;else if(t>1)t=1;
      var pos=100-t*100;
      block.style.setProperty('--egde-welcome-pos',pos+'%');
    }
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    function loop(){update();requestAnimationFrame(loop);}
    requestAnimationFrame(loop);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else setTimeout(init,200);
})();

;(function(){
  function init(){
    var hc = document.querySelector("header-component");
    if (!hc) return;
    var origLogo = hc.querySelector(".header-logo");
    if (!origLogo) return;
    if (hc.querySelector(".egde-center-logo-strip")) return;
    var strip = document.createElement("div");
    strip.className = "egde-center-logo-strip";
    var clone = origLogo.cloneNode(true);
    clone.classList.add("egde-center-logo-clone");
    strip.appendChild(clone);
    var firstRow = hc.querySelector(".header__row");
    if (firstRow) { hc.insertBefore(strip, firstRow); } else { hc.appendChild(strip); }
    var hdr = document.querySelector(".header-section");
    function forceFrosted(){
      if(hdr){
        hdr.style.setProperty("background", "rgba(255,255,255,0.55)", "important");
        hdr.style.setProperty("background-color", "rgba(255,255,255,0.55)", "important");
        hdr.style.setProperty("backdrop-filter", "saturate(180%) blur(22px)", "important");
        hdr.style.setProperty("-webkit-backdrop-filter", "saturate(180%) blur(22px)", "important");
      }
      hc.style.setProperty("background", "transparent", "important");
      hc.style.setProperty("background-color", "transparent", "important");
      hc.style.setProperty("backdrop-filter", "none", "important");
      hc.style.setProperty("-webkit-backdrop-filter", "none", "important");
      var inner = hc.querySelectorAll(".header__row, .header__row--top, .egde-center-logo-strip, .header__columns, .header__column, .header-menu");
      inner.forEach(function(el){el.style.setProperty("background", "transparent", "important"); el.style.setProperty("background-color", "transparent", "important");});
      
    }
    forceFrosted();
    var TOP_ZONE = 60;
    var DOWN_TH = 80;
    var UP_TH = 80;
    var sentinel = window.scrollY;
    var state = "";
    var ticking = false;
    function applyStripHeight(){ var strip = hc.querySelector(".egde-center-logo-strip"); if(!strip) return; var isMobile = window.innerWidth <= 768; var defaultH = isMobile ? 60 : 38; var isCollapsed = hc.getAttribute("data-egde-header") === "collapsed"; strip.style.setProperty("height", (isCollapsed ? 0 : defaultH) + "px", "important"); } function setState(s){ if (s !== state) { state = s; hc.setAttribute("data-egde-header", s); applyStripHeight(); } } applyStripHeight(); window.addEventListener("resize", applyStripHeight);
    function tick(){
      ticking = false;
      var sy = window.scrollY;
      if (sy < TOP_ZONE) { setState("expanded"); sentinel = sy; return; }
      if (state !== "collapsed") {
        if (sy > sentinel + DOWN_TH) { setState("collapsed"); sentinel = sy; }
        else if (sy < sentinel) { sentinel = sy; }
      } else {
        if (sy < sentinel - UP_TH) { setState("expanded"); sentinel = sy; }
        else if (sy > sentinel) { sentinel = sy; }
      }
    }
    function onScroll(){ if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
    setState("expanded");
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function(){ forceFrosted(); onScroll(); });
    setTimeout(forceFrosted, 500);
    setTimeout(forceFrosted, 1500);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else setTimeout(init, 150);
})();

/* EGDE 404 cache rescue 2026-06-03 start */
(function () {
  function egdeApply404Rescue() {
    var main = document.querySelector('#MainContent[data-template="404"]');
    var root = main && main.querySelector('.egde-404-elastic');
    if (!root) return;

    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var path = (window.location.pathname || '').toLowerCase();
    var isZh = lang.indexOf('zh') === 0 || path.indexOf('/zh/') === 0;
    var isEn = lang.indexOf('en') === 0 || path.indexOf('/en/') === 0;
    var title = 'このページはまだ公開前です。';
    var lines = ['発売時間になると商品ページが表示されます。', '公開までしばらくお待ちください。'];

    if (isZh) {
      title = '此頁面尚未公開。';
      lines = ['商品頁面將於發售時間開放。', '請稍候再查看。'];
    } else if (isEn) {
      title = 'This page is not available yet.';
      lines = ['The product page will open at the release time.', 'Please check back soon.'];
    }

    var titleEl = root.querySelector('.egde-404-elastic__title');
    var copyEl = root.querySelector('.egde-404-elastic__copy');
    if (titleEl) titleEl.textContent = title;
    if (copyEl) {
      copyEl.innerHTML = lines.map(function (line) { return '<p>' + line + '</p>'; }).join('');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', egdeApply404Rescue);
  } else {
    egdeApply404Rescue();
  }
  window.addEventListener('pageshow', egdeApply404Rescue);
  setTimeout(egdeApply404Rescue, 300);
  setTimeout(egdeApply404Rescue, 1200);
})();
/* EGDE 404 cache rescue 2026-06-03 end */

/* real-skin-runway-cachefix-v12 START */
(function(){
  var STAMP = '202606091307-cachefix-v12';
  if (!/\/pages\/real-skin/.test(location.pathname)) return;
  function installStyle(){
    if (document.getElementById('real-skin-runway-cachefix-v12-style')) return;
    var style = document.createElement('style');
    style.id = 'real-skin-runway-cachefix-v12-style';
    style.textContent = '.rs-apple .rs-runway__viewport.is-looping{overflow-x:auto!important;overflow-y:hidden!important;-webkit-overflow-scrolling:touch;overscroll-behavior-inline:contain;touch-action:pan-x}.rs-apple .rs-runway__track,.rs-apple .rs-runway__track.is-looping,.rs-apple .rs-runway__track.is-js-looping{display:flex!important;gap:0!important;width:max-content!important;min-width:max-content!important;transform:none!important;animation:none!important;will-change:auto!important}.rs-apple .rs-runway__set,.rs-apple .rs-runway__set[aria-hidden="true"],.rs-apple .rs-runway__set[data-rs-loop-clone="true"],.rs-apple .rs-runway__set[data-rs-loop-origin="true"]{display:flex!important;flex:0 0 auto!important;min-width:max-content!important;visibility:visible!important;opacity:1!important}.rs-apple .rs-runway__set[data-rs-loop-clone="true"] .rs-runway__frame{visibility:visible!important;opacity:.98!important}.rs-apple .rs-runway__frame,.rs-apple .rs-runway__frame img{visibility:visible!important}.rs-apple .rs-runway__frame img{display:block;width:100%}@media(max-width:900px){.rs-apple .rs-runway__set,.rs-apple .rs-runway__set[aria-hidden="true"],.rs-apple .rs-runway__set[data-rs-loop-clone="true"],.rs-apple .rs-runway__set[data-rs-loop-origin="true"]{gap:12px!important;padding-right:12px!important}}';
    document.head.appendChild(style);
  }
  function prepareSet(set, decorative, slot){
    if (!set) return;
    set.classList.add('rs-runway__set');
    set.removeAttribute('inert');
    set.removeAttribute('aria-hidden');
    set.style.display = 'flex';
    set.style.visibility = 'visible';
    set.style.opacity = '1';
    set.setAttribute('data-rs-cachefix-slot', String(slot));
    if (decorative) {
      set.setAttribute('role', 'presentation');
      set.setAttribute('data-rs-loop-clone', 'true');
      set.removeAttribute('data-rs-loop-origin');
    } else {
      set.removeAttribute('role');
      set.removeAttribute('data-rs-loop-clone');
      set.setAttribute('data-rs-loop-origin', 'true');
    }
    Array.prototype.forEach.call(set.querySelectorAll('.rs-reveal'), function(el){ el.classList.remove('rs-reveal'); el.classList.add('is-visible'); el.style.transitionDelay = '0ms'; });
    Array.prototype.forEach.call(set.querySelectorAll('.rs-runway__frame'), function(frame){
      frame.classList.add('is-visible');
      frame.style.visibility = 'visible';
      frame.style.opacity = '1';
      frame.removeAttribute('aria-hidden');
      if (decorative) frame.setAttribute('role','presentation');
      else frame.removeAttribute('role');
    });
    Array.prototype.forEach.call(set.querySelectorAll('img'), function(img){
      var src = img.currentSrc || img.getAttribute('src') || img.src;
      if (src) img.setAttribute('src', src);
      img.setAttribute('loading','eager');
      img.setAttribute('decoding','async');
      img.style.visibility = 'visible';
      img.style.opacity = '1';
      img.removeAttribute('aria-hidden');
      try { img.fetchPriority = decorative ? 'low' : 'high'; } catch(e) {}
      if (decorative) { img.setAttribute('alt',''); img.setAttribute('role','presentation'); }
      else { img.removeAttribute('role'); }
    });
  }
  function patchRunway(){
    var root = document.querySelector('.rs-apple');
    if (!root) return false;
    var viewport = root.querySelector('.rs-runway__viewport');
    var track = root.querySelector('.rs-runway__track');
    if (!viewport || !track) return false;
    if (track.dataset.rsCachefixRunway === 'v12') return true;
    installStyle();
    var sets = Array.prototype.slice.call(track.querySelectorAll('.rs-runway__set'));
    var source = sets.filter(function(set){ return set.getAttribute('data-rs-loop-origin') === 'true'; })[0] || sets[0];
    if (!source) return false;
    var sourceHtml = source.innerHTML;
    track.dataset.rsCachefixRunway = 'v12';
    track.dataset.rsSafariLoop = 'cachefix-v12';
    track.dataset.rsEmergencyRunway = 'none';
    track.style.transform = 'none';
    track.style.animation = 'none';
    track.style.width = '';
    track.innerHTML = '';
    var total = 7;
    var originSlot = 3;
    for (var i=0; i<total; i++) {
      var set = document.createElement('div');
      set.className = 'rs-runway__set';
      set.innerHTML = sourceHtml;
      prepareSet(set, i !== originSlot, i);
      track.appendChild(set);
    }
    viewport.classList.add('is-looping');
    track.classList.add('is-looping','is-js-looping');
    var state = { width:0, start:0, ready:false, normalizing:false, last:0 };
    function measure(){
      var newSets = Array.prototype.slice.call(track.querySelectorAll('.rs-runway__set'));
      var origin = newSets.filter(function(set){ return set.getAttribute('data-rs-loop-origin') === 'true'; })[0] || newSets[originSlot];
      var originIndex = newSets.indexOf(origin);
      var next = newSets[originIndex + 1];
      if (!origin || !next) return;
      state.start = Math.round(origin.offsetLeft || (origin.getBoundingClientRect().left - track.getBoundingClientRect().left));
      var end = Math.round(next.offsetLeft || (next.getBoundingClientRect().left - track.getBoundingClientRect().left));
      state.width = Math.round(end - state.start);
      track.dataset.rsLoopUsable = String(origin.querySelectorAll('.rs-runway__frame').length);
      track.dataset.rsLoopSetWidth = String(state.width || 0);
      track.dataset.rsLoopBaseStart = String(state.start || 0);
      if (state.width > 0 && !state.ready) {
        setScroll(state.start + Math.min(viewport.clientWidth * .14, state.width * .14));
        state.ready = true;
      }
    }
    function setScroll(left){
      state.normalizing = true;
      viewport.scrollLeft = Math.max(0, Math.round(left));
      requestAnimationFrame(function(){ state.normalizing = false; });
    }
    function normalize(force){
      if (!state.width || state.normalizing) return;
      var left = viewport.scrollLeft;
      var target = left;
      var lower = state.start - state.width * .65;
      var upper = state.start + state.width * 1.65;
      while (target < lower) target += state.width;
      while (target > upper) target -= state.width;
      if (force || Math.abs(target - left) > 1) setScroll(target);
    }
    function tick(now){
      if (!viewport.isConnected || track.dataset.rsCachefixRunway !== 'v12') return;
      if (!state.width) measure();
      if (!state.last) state.last = now;
      var delta = Math.min((now - state.last) / 1000, .05);
      state.last = now;
      if (state.width && !state.normalizing) {
        track.style.transform = 'none';
        track.style.animation = 'none';
        viewport.scrollLeft = viewport.scrollLeft + 104 * delta;
        normalize(false);
      }
      requestAnimationFrame(tick);
    }
    var ticking = false;
    viewport.addEventListener('scroll', function(){
      if (state.normalizing || ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ ticking = false; normalize(false); });
    }, { passive:true });
    Array.prototype.forEach.call(track.querySelectorAll('img'), function(img){ if (!img.complete) img.addEventListener('load', measure, { once:true }); });
    measure();
    setTimeout(function(){ measure(); normalize(true); }, 700);
    setInterval(function(){ normalize(false); }, 300);
    addEventListener('resize', function(){ state.ready = false; measure(); normalize(true); });
    document.addEventListener('visibilitychange', function(){ state.last = 0; });
    requestAnimationFrame(tick);
    document.documentElement.setAttribute('data-real-skin-runway-cachefix', STAMP);
    return true;
  }
  function boot(){
    if (patchRunway()) return;
    var tries = 0;
    var timer = setInterval(function(){ tries++; if (patchRunway() || tries > 24) clearInterval(timer); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  addEventListener('load', patchRunway);
})();
/* real-skin-runway-cachefix-v12 END */

/* real-skin-flow-strip-runtime-v3 START */
(function(){
  if (!/\/pages\/real-skin/.test(location.pathname)) return;
  var MARK = 'flow-strip-runtime-v3-202606091357';
  function style(){
    if (document.getElementById('rs-flow-strip-runtime-v3-style')) return;
    var s = document.createElement('style');
    s.id = 'rs-flow-strip-runtime-v3-style';
    s.textContent = '.rs-flow-final{overflow:hidden!important}.rs-flow-final__viewport{width:100vw!important;overflow:hidden!important;contain:none!important}.rs-flow-final__strip{display:flex!important;width:max-content!important;min-width:max-content!important;gap:18px!important;will-change:transform!important;contain:none!important}.rs-flow-final__strip .rs-flow-final__frame{flex:0 0 clamp(236px,24vw,358px)!important;height:clamp(315px,35vw,476px)!important;margin:0!important;overflow:hidden!important;background:#111!important;visibility:visible!important;opacity:1!important}.rs-flow-final__strip .rs-flow-final__frame img{display:block!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;visibility:visible!important;opacity:1!important}@media(max-width:900px){.rs-flow-final__strip{gap:12px!important}.rs-flow-final__strip .rs-flow-final__frame{flex-basis:72vw!important;height:92vw!important}}';
    document.head.appendChild(s);
  }
  function imgHtml(src, alt, i){
    return '<figure class="rs-flow-final__frame" data-rs-flow-index="'+i+'"><img src="'+src.replace(/"/g,'&quot;')+'" alt="'+(alt||'Real Skin visual flow').replace(/"/g,'&quot;')+'" loading="eager" decoding="async"></figure>';
  }
  function install(){
    var root = document.querySelector('.rs-flow-final');
    if (!root || root.dataset.rsFlowRuntime === 'v3') return !!root;
    var viewport = root.querySelector('.rs-flow-final__viewport');
    if (!viewport) return false;
    style();
    var sourceImgs = Array.prototype.slice.call(root.querySelectorAll('.rs-flow-final__frame img'));
    var seen = [];
    sourceImgs.forEach(function(img){
      var src = img.currentSrc || img.getAttribute('src') || img.src;
      if (!src) return;
      if (seen.some(function(x){ return x.src === src; })) return;
      seen.push({ src: src, alt: img.getAttribute('alt') || 'Real Skin visual flow' });
    });
    if (seen.length < 12) return false;
    seen = seen.slice(0, 24);
    var one = seen.map(function(x,i){ return imgHtml(x.src, x.alt, i+1); }).join('');
    var all = '';
    for (var r=0; r<5; r++) all += one;
    viewport.innerHTML = '<div class="rs-flow-final__strip" data-rs-flow-strip="runtime-v3">'+all+'</div>';
    var strip = viewport.querySelector('.rs-flow-final__strip');
    root.dataset.rsFlowRuntime = 'v3';
    root.setAttribute('data-rs-flow-runtime', 'v3');
    var state = { offset:0, setWidth:0, last:0, dragging:false, sx:0, sy:0, startOffset:0 };
    function ensureImages(){
      Array.prototype.forEach.call(strip.querySelectorAll('img'), function(img){
        var src = img.currentSrc || img.getAttribute('src') || img.src;
        if (src) img.setAttribute('src', src);
        img.setAttribute('loading','eager'); img.setAttribute('decoding','async');
        img.style.visibility='visible'; img.style.opacity='1';
        try { img.fetchPriority='high'; } catch(e) {}
      });
    }
    function measure(){
      ensureImages();
      var frames = strip.querySelectorAll('.rs-flow-final__frame');
      if (frames.length > 24) state.setWidth = Math.round(frames[24].offsetLeft - frames[0].offsetLeft);
      if (!state.setWidth) state.setWidth = Math.round(strip.scrollWidth / 5);
      strip.dataset.rsFlowSetWidth = String(state.setWidth || 0);
      render();
    }
    function mod(v){ if (!state.setWidth) return 0; v = v % state.setWidth; return v < 0 ? v + state.setWidth : v; }
    function render(){
      state.offset = mod(state.offset);
      strip.style.setProperty('transform', 'translate3d(' + (-state.offset) + 'px,0,0)', 'important');
      strip.dataset.rsFlowOffset = String(Math.round(state.offset));
    }
    function move(delta){ state.offset = mod(state.offset + delta); render(); }
    function tick(now){
      if (!strip.isConnected) return;
      if (!state.setWidth) measure();
      if (!state.last) state.last = now;
      var dt = Math.min((now - state.last) / 1000, .05);
      state.last = now;
      move(44 * dt);
      requestAnimationFrame(tick);
    }
    viewport.addEventListener('wheel', function(e){ if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; e.preventDefault(); move(e.deltaX); }, { passive:false });
    viewport.addEventListener('pointerdown', function(e){ state.dragging=true; state.sx=e.clientX; state.sy=e.clientY; state.startOffset=state.offset; try { viewport.setPointerCapture(e.pointerId); } catch(err) {} });
    viewport.addEventListener('pointermove', function(e){ if (!state.dragging) return; var dx=e.clientX-state.sx, dy=e.clientY-state.sy; if (Math.abs(dx) > Math.abs(dy)) { e.preventDefault(); state.offset=mod(state.startOffset-dx); render(); } }, { passive:false });
    function endDrag(){ state.dragging=false; state.last=0; }
    viewport.addEventListener('pointerup', endDrag); viewport.addEventListener('pointercancel', endDrag); viewport.addEventListener('mouseleave', endDrag);
    Array.prototype.forEach.call(strip.querySelectorAll('img'), function(img){ if (!img.complete) img.addEventListener('load', measure, { once:true }); });
    measure(); setTimeout(measure, 700); addEventListener('resize', measure); requestAnimationFrame(tick);
    window.__realSkinFlowRuntimeV3 = { move:move, setOffset:function(v){ state.offset=v; render(); }, getState:function(){ return { offset:state.offset, setWidth:state.setWidth, frames:strip.querySelectorAll('.rs-flow-final__frame').length }; } };
    document.documentElement.setAttribute('data-real-skin-flow-runtime', MARK);
    return true;
  }
  function boot(){ if (install()) return; var n=0,t=setInterval(function(){ n++; if (install() || n>30) clearInterval(t); }, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  addEventListener('load', install);
})();
/* real-skin-flow-strip-runtime-v3 END */

/* EGDE LIVE globe slash rescue 20260618 */
(function(){
  try {
    if (window.location && window.location.pathname === "/pages/egde-live-globe") {
      window.location.replace("/pages/egde-live-globe-live" + window.location.search + window.location.hash);
    }
  } catch (error) {}
})();
/* EGDE LIVE globe slash rescue 20260618 end */

/* EGDE CYBER HOME / 0904 copy / 2026-09-07 */
(function () {
  var hero = document.querySelector('[id*="video_brand_frontier"]');
  var catalog = document.querySelector('[id*="product_list_ed3c8h"]');
  if (!hero || !catalog) return;

  document.documentElement.classList.add('egde-cyber-home');
  if (document.body) document.body.classList.add('egde-cyber-home');

  function installDepthMotion() {
    var scenes = [
      hero.querySelector('.slideshow-section'),
      document.querySelector('[id*="slideshow_mAY6gk"] .slideshow-section')
    ].filter(Boolean);

    var floatingSections = [
      catalog.querySelector('.section-resource-list__header .group-block-content'),
      catalog.querySelector('.resource-list'),
      document.querySelector('[id*="slideshow_mAY6gk"] slideshow-component'),
      document.querySelector('[id*="carousel_kEmBPB"] .section-carousel'),
      document.querySelector('[id*="social_links"]'),
      document.querySelector('.egde-latest-info__inner')
    ].filter(Boolean);

    floatingSections.forEach(function (section, index) {
      section.setAttribute('data-egde-cyber-float', String(index + 1));
    });

    if (!scenes.length && !floatingSections.length) return;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var ticking = false;
    function update() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
      var isMobile = viewportWidth < 750;
      var travel = window.innerWidth < 750 ? 12 : 26;
      var pageHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      var pageRange = Math.max(1, pageHeight - viewportHeight);
      var pageProgress = Math.max(0, Math.min(1, window.scrollY / pageRange));
      var worldTravel = isMobile ? 20 : 36;
      var worldShift = (.5 - pageProgress) * worldTravel;

      document.documentElement.style.setProperty(
        '--egde-cyber-world-y',
        worldShift.toFixed(2) + 'px'
      );

      scenes.forEach(function (scene) {
        var rect = scene.getBoundingClientRect();
        var centerOffset = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
        var shift = Math.max(-travel, Math.min(travel, centerOffset * travel));
        scene.style.setProperty('--egde-cyber-depth-y', shift.toFixed(2) + 'px');
      });

      floatingSections.forEach(function (section, index) {
        var rect = section.getBoundingClientRect();
        var centerOffset = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
        var sectionTravel = isMobile ? 7 : 14;
        var direction = index % 2 === 0 ? 1 : -1;
        var shift = Math.max(
          -sectionTravel,
          Math.min(sectionTravel, centerOffset * sectionTravel * direction)
        );
        section.style.setProperty('--egde-cyber-section-y', shift.toFixed(2) + 'px');
      });
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();

    var finePointer = window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (finePointer) {
      scenes.forEach(function (scene) {
        if (scene.dataset.egdeCyberPointer === 'ready') return;
        scene.dataset.egdeCyberPointer = 'ready';

        var pointerFrame = 0;
        var pointerX = 0;
        function paintPointerDepth() {
          scene.style.setProperty('--egde-cyber-depth-x', pointerX.toFixed(2) + 'px');
          document.documentElement.style.setProperty(
            '--egde-cyber-world-x',
            pointerX.toFixed(2) + 'px'
          );
          pointerFrame = 0;
        }

        scene.addEventListener('pointermove', function (event) {
          var rect = scene.getBoundingClientRect();
          var ratio = rect.width ? (event.clientX - rect.left) / rect.width - .5 : 0;
          pointerX = Math.max(-18, Math.min(18, ratio * 24));
          if (!pointerFrame) pointerFrame = window.requestAnimationFrame(paintPointerDepth);
        }, { passive: true });

        scene.addEventListener('pointerleave', function () {
          pointerX = 0;
          if (!pointerFrame) pointerFrame = window.requestAnimationFrame(paintPointerDepth);
        }, { passive: true });
      });
    }
  }

  function decorate() {
    var productItems = Array.prototype.slice.call(
      catalog.querySelectorAll('.resource-list__item')
    );
    productItems.forEach(function (item, index) {
      item.setAttribute('data-egde-cyber-index', String(index + 1).padStart(2, '0'));
    });

    var targets = [];
    targets = targets.concat(Array.prototype.slice.call(
      catalog.querySelectorAll('.section-resource-list__header .text-block, .resource-list__item')
    ));

    var stores = document.querySelector('[id*="slideshow_mAY6gk"] slideshow-component');
    if (stores) targets.push(stores);

    var lookbook = document.querySelector('[id*="carousel_kEmBPB"]');
    if (lookbook) {
      targets = targets.concat(Array.prototype.slice.call(
        lookbook.querySelectorAll('.card:not(.clone)')
      ));
    }

    var social = document.querySelector('[id*="social_links"]');
    if (social) {
      targets = targets.concat(Array.prototype.slice.call(
        social.querySelectorAll('a[href*="instagram"], a[href*="x.com"], a[href*="lin.ee"]')
      ));
    }

    targets = targets.concat(Array.prototype.slice.call(
      document.querySelectorAll('.egde-latest-info__header, .egde-latest-info__item')
    ));

    targets.forEach(function (target, index) {
      if (target.classList.contains('egde-cyber-reveal')) return;
      target.classList.add('egde-cyber-reveal');
      target.style.setProperty('--egde-cyber-delay', String((index % 4) * 65) + 'ms');
    });

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (target) {
        target.classList.add('egde-cyber-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('egde-cyber-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -28px 0px'
    });

    targets.forEach(function (target) {
      observer.observe(target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      decorate();
      installDepthMotion();
    }, { once: true });
  } else {
    decorate();
    installDepthMotion();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', decorate);
  }
})();
/* EGDE CYBER HOME end */
